import { log } from 'log';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { parseJwtToken } from 'js/utils/pas.util';
import { useCallback, useEffect, useState } from 'react';
import { storageService } from 'js/services/storage.service';
import { userSetAttributesAction } from 'js/hooks/user/store/actions';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import { useGenericLogin } from './useGenericLogin';

export const useLoginByGoogleToken = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const genericLogin = useGenericLogin();
    const closePopups = useSmartClosePopups();
    const registrationURL = useAppSelector(prop('registrationURL'));
    const [isNavigateToRegister, setIsNavigateToRegister] = useState<boolean>(false);

    // this effect is needed since on genericLogin catch "registrationURL" is undefined
    useEffect(() => {
        if (isNavigateToRegister && registrationURL) {
            navigate(registrationURL);
            closePopups();
        }
    }, [registrationURL, navigate, isNavigateToRegister, closePopups]);

    return useCallback(async ({ token, isAutoLogin }: { token: string; isAutoLogin?: boolean }) => {
        const userData = parseJwtToken<IGoogleJWTToken>(token);

        storageService.local.removeItem('externalLoginBackURL');
        storageService.local.removeItem('isExternalLoginLinkAccount');

        genericLogin({ inputPassword: token, loginMode: 'externalToken', isRecaptchaEnabled: true, isAutoLogin })
            .catch((error: any) => {
                switch (error?.data?.errorCode) {
                    case 2:
                    case 104:
                        // saving data to be autofilled within registration form
                        dispatch(userSetAttributesAction({
                            registrationInfo: {
                                email: userData.email || '',
                                identityToken: token,
                                firstname: userData.given_name || '',
                                lastname: userData.family_name || ''
                            }
                        }));

                        setIsNavigateToRegister(true);

                        break;
                    default:
                        log('error', '[Google login] loginByCredentials failed', error);
                    }
            });
    }, [dispatch, genericLogin, setIsNavigateToRegister]);
};
